import { TemplatingContextType } from '@tyro/api';

export const contextByUrl = {
  students: TemplatingContextType.Student,
  staff: TemplatingContextType.Staff,
  contacts: TemplatingContextType.Contact,
  assessments: TemplatingContextType.Assessment,
  person: TemplatingContextType.Person,
} as const;
